import styled from 'styled-components'

import Modal from 'react-modal'

import { FaWindowClose } from "react-icons/fa"

export const Container = styled(Modal)`  
width: 80%;
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
outline: none;

  @media (min-width: 768px) {
    width: 50%;
  }

  @media (min-width: 1024px) {
    width: 40%;
  }

  @media (min-width: 1440px) {
    width: 30%;
  }
`;

// Modal de conteudo: superficie CLARA (DESIGN.md > Componentes). Os cards
// e botoes dentro dele seguem a regra de card e ficam escuros.
export const Content = styled.div`   
  background-color: ${({ theme }) => theme.colors.background};   
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;  
  border-bottom-right-radius: 16px;
  border-bottom-left-radius: 16px;
`;

export const CloseButton = styled.button`
  width: 100%;
  border: none;
  display: flex;
  justify-content: start;
  background-color: ${({ theme }) => theme.colors.background};
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`

export const CloseIcon = styled(FaWindowClose).attrs(({ theme }) => ({
  color: theme.colors.textSecondary,
  size: 32,
}))`
  margin: 16px;   
`;
